<mat-sidenav-container class="nk-layout-container">
  <!-- Sidebar: Left -->
  <mat-sidenav
    *ngIf="sideBarConfig?.type === 'left'"
    mode="over"
    opened
    [disableClose]="true"
   class="navbar-left"
    position="start"
  >
    <app-sidebar
      [name]="'navbar'"
      [config]="sideBarConfig"
      
      [ngClass]="nkSettings.colorClasses.navbar || 'bg-trans'"
      (backdropClicked)="navbarBackDropClicked()"
       *ngIf="sideBarConfig.type === 'left'"
    >
      <app-navbar layout="vertical"></app-navbar>
    </app-sidebar>
     
  </mat-sidenav>

  <!-- Sidebar: Right -->
  

  <mat-sidenav
    *ngIf="sideBarConfig?.type === 'right'"
    mode="side"
    opened
    position="end"
    class="nk-sidenav"
  >
    <app-sidebar
      [name]="'navbar'"
      [config]="sideBarConfig"
      [ngClass]="nkSettings?.colorClasses?.navbar || 'bg-trans'"
      (backdropClicked)="navbarBackDropClicked()"
    >
      <app-navbar layout="vertical"></app-navbar>
    </app-sidebar>
  </mat-sidenav>

  <!-- Quick Panel -->
<mat-sidenav
  appNkMatSidenavHelper="quick-panel"
  position="end"
  mode="over"
  [disableClose]="false"
  class="quick-panel-sidenav"
  (backdropClick)="logBackdropClick(); onBackdropClick()"
  #quickPanel
>
  <app-quick-panel></app-quick-panel>
</mat-sidenav>


  <!-- Main Content -->
  <mat-sidenav-content   >
    <div id="nk-main-content">
      <!-- TOOLBAR: Above -->
      <ng-container *ngIf="nkSettings?.layout?.toolbar === 'above'"
      >
        <app-toolbar
          class="above"
          [ngClass]="nkSettings?.colorClasses?.toolbar"
        ></app-toolbar>
      </ng-container>

      <!-- NAVBAR: Top -->
      <!-- <app-navbar
        layout="horizontal"
        class="top-navbar"
        fxHide
        fxShow.gt-md
        [ngClass]="nkSettings?.colorClasses?.navbar || 'bg-trans'"
        *ngIf="sideBarConfig?.type === 'left'"
      ></app-navbar> -->

      <!-- Content Wrapper -->
      <div class="content-wrapper">
        <!-- TOOLBAR: Below -->
        <ng-container *ngIf="nkSettings?.layout?.toolbar === 'below'">
          <app-toolbar
            class="below"
            [ngClass]="nkSettings?.colorClasses?.toolbar"
          ></app-toolbar>
        </ng-container>

        <!-- Main App Content -->
        <app-content></app-content>

        <!-- FOOTER: Below -->
        <ng-container *ngIf="nkSettings?.layout?.footer === 'below'">
          <nk-footer
            class="below"
            [ngClass]="nkSettings?.colorClasses?.footer"
          ></nk-footer>
        </ng-container>
      </div>

      <!-- FOOTER: Above -->
      <ng-container *ngIf="nkSettings?.layout?.footer === 'above'">
        <nk-footer
          class="above"
          [ngClass]="nkSettings?.colorClasses?.footer"
        ></nk-footer>
      </ng-container>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- Theme Options Panel -->
<app-theme-options [navigation]="navMenu$ | async"></app-theme-options>
